import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import { Row, Col, Container } from "react-bootstrap";

import "../styles/main.css";
import "../styles/hover.css";
import AnimatedElement from "./AnimatedElement";

const ExpertiseComponent = () => {
  const { t } = useTranslation();
  const webDevelopmentImage = require("../assets/images/web-development.webp");
  const uxuiDesignImage = require("../assets/images/ux-ui-design.webp");
  const graphicDesignImage = require("../assets/images/graphic-design.webp");
  const multimediaEditingImage = require("../assets/images/multimedia-editing.webp");

  return (
    <>
      <section id="expertise-section" className="text-center px-3">
        <AnimatedElement>
          <h2
            className="sub-header hvr-wobble-vertical"
            id="subtitle-expertise"
          >
            {t('expertise.title')}
          </h2>
        </AnimatedElement>

        <Container id="expertise-cards-section">
          <Row xl={4} lg={4} md={2} sm={1} xs={1} className="g-4">
            <AnimatedElement>
              <Col className="hvr-grow-rotate">
                <Card className="h-100 expertise-card">
                  <Card.Img
                    src={webDevelopmentImage}
                    alt={t('expertise.webDev')}
                  />
                </Card>
              </Col>
            </AnimatedElement>

            <AnimatedElement>
              <Col className="hvr-grow-rotate">
                <Card className="h-100 expertise-card">
                  <Card.Img
                    src={uxuiDesignImage}
                    alt={t('expertise.uxui')}
                  />
                </Card>
              </Col>
            </AnimatedElement>

            <AnimatedElement>
              <Col className="hvr-grow-rotate">
                <Card className="h-100 expertise-card">
                  <Card.Img
                    src={graphicDesignImage}
                    alt={t('expertise.graphic')}
                  />
                </Card>
              </Col>
            </AnimatedElement>

            <AnimatedElement>
              <Col className="hvr-grow-rotate">
                <Card className="h-100 expertise-card">
                  <Card.Img
                    src={multimediaEditingImage}
                    alt={t('expertise.multimedia')}
                  />
                </Card>
              </Col>
            </AnimatedElement>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ExpertiseComponent;
